"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/BZFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_39)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_39`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6.59998 0H29.4V24H-6.59998V0Z",
					fill: "#003E87"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.7088 20.3368C16.317 20.3368 20.0527 16.6012 20.0527 11.993C20.0527 7.38478 16.317 3.64911 11.7088 3.64911C7.10066 3.64911 3.36499 7.38478 3.36499 11.993C3.36499 16.6012 7.10066 20.3368 11.7088 20.3368Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.7789 18.7789C15.4414 18.7789 18.4105 15.8099 18.4105 12.1474C18.4105 8.48484 15.4414 5.51578 11.7789 5.51578C8.1164 5.51578 5.14734 8.48484 5.14734 12.1474C5.14734 15.8099 8.1164 18.7789 11.7789 18.7789Z",
					stroke: "#6DA544",
					strokeWidth: 1.26316,
					strokeMiterlimit: 10
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.779 10.6316L8.22815 12.2737V13.6772C8.22815 14.5053 8.65622 15.2772 9.36499 15.7053L11.786 16.7719L14.2071 15.7053C14.9089 15.2702 15.3439 14.5053 15.3439 13.6772V12.2737L11.779 10.6316Z",
					fill: "#003E87",
					stroke: "black",
					strokeWidth: .0701754
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.22815 8.98947H15.3369V12.2667H8.22815V8.98947Z",
					fill: "#FFDA44",
					stroke: "black",
					strokeWidth: .0701754
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6.59998 0H29.4V2.45614H-6.59998V0ZM-6.59998 21.4737H29.4V23.9298H-6.59998V21.4737Z",
					fill: "#CE1127"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_39`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as BZFlag };
